<template>
  <div>
    <div class="search-top-row">
      <el-row>
        <el-col style="text-align:center">
          <el-input class="budget-input" v-model="queryParam.quotaName" placeholder="请输入预算名称" clearable filterable></el-input>
          <el-input class="budget-input" v-model="queryParam.quotaCode" placeholder="请输入预算编码" clearable filterable></el-input>
          <span class="search-text">日期区间</span>
          <el-date-picker v-model="queryParam.effectiveDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
          <span class="search-text">至</span>
          <el-date-picker class="input-right" v-model="queryParam.expireDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
          <el-button class="btn-red" size="small" @click="getBudgetList()">搜索</el-button>
        </el-col>
      </el-row>
      <div v-for="(item, index) in quotaList" :key="index" class="margin-bottom-20">
        <el-card shadow="hover" class="cursor" @click.native="handleDetail(item,item.quotaTypeName)">
          <el-row>
            <el-col :span="12">
              <el-row>
                <div class="margin-bottom-10 quotaName">{{ item.quotaName }}</div>
              </el-row>
              <el-row>
                <div class="margin-bottom-10" style="color: #C8102D">{{ item.quotaTypeName }}</div>
              </el-row>
              <el-row>
                <div
                  class="margin-bottom-10 font-color"
                >{{ item.effectiveDate | parseTime('{y}.{m}.{d}')}} - {{ item.expireDate | parseTime('{y}.{m}.{d}')}}</div>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <div class="margin-bottom-10">
                  全部配额：
                  <span class="font-color">{{ item.totalQuota | thousandSymbol}}</span>
                  <span v-show="item.quotaType == '01' || item.quotaType == '03' || item.quotaType == '04'">元</span>
                </div>
                <div class="margin-bottom-10">
                  可用配额：
                  <span class="font-color">{{ item.availableQuota | thousandSymbol}}</span>
                  <span v-show="item.quotaType == '01' || item.quotaType == '03' || item.quotaType == '04'">元</span>
                </div>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <el-row class="while-data-table-footer">
        <el-col>
          <el-pagination
            background
            :current-page="queryParam.page"
            :page-size="queryParam.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import budgetApi from '@/api/budget'
export default {
  name: 'budget-grid-info',
  components: {
  },
  props: {},
  data () {
    return {
      loading: false,
      queryParam: {
        page: 1,
        pageSize: 10,
        quatoCode: '',
        quatoName: '',
        effectiveDate: '',
        expireDate: ''
      },
      quotaList: [],
      total: null
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getBudgetList()
    },

    // 获取预算列表
    getBudgetList () {
      this.loading = true
      budgetApi
        .getBudgetList(this.queryParam)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.quotaList = res.data.resultData.quotaList
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    handleCurrentChange (val) {
      this.queryParam.page = val
      this.getBudgetList()
    },

    handleDetail (item, type) {
      type = type === 'TR金额配额' ? 1 : 0
      this.$router.push({
        path: '/budget/grid-detail',
        query: {
          quotaId: item.quotaId,
          type
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-bottom-10 {
  margin-bottom: 10px;
}
.margin-bottom-20 {
  margin-bottom: 20px;
}
.font-color {
  color: #888888;
}
.font-bold {
  font-weight: bold;
}

.search-top-row {
  width: 1000px;
  margin: 0 auto;
}

.budget-input.el-input {
  width: 180px;
  height: 36px;
  margin: 0 20px 20px 0;
  input::-webkit-input-placeholder {
    color: #000;
  }
}
.el-select {
  width: 140px;
  height: 36px;
  margin: 0 20px 20px 0;
}
.search-text {
  font-size: $font-12;
  display: inline-block;
  height: 38px;
  padding: 0 5px;
  line-height: 38px;
  background-color: #d8d8d8;
}
.search-top-row .el-date-editor {
  width: 140px;
}
.range-input {
  width: 65px;

  ::v-deep .el-input__inner {
    padding: 0 5px;
  }
}
.input-right {
  margin-right: 20px;
}
.budget-grid-info {
  margin-top: 20px;
}
.quotaName {
  font-size: 18px;
  font-weight: bold;
}
</style>
